<template>
  <div>
    <!-- 搬定讲师 -->
    <el-dialog :title="$t('message.boundInstructor')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <el-select v-model="datas.gk" filterable>
          <el-option v-for="item in GkUserList" :key="item.id" :label="item.realname" :value="item.id">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <!-- <el-button @click="$parent.addExpressDialogVisible = false">{{
          $t("message.cancel")
        }}</el-button> -->
        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
      $t("message.save")
          }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    ids: { type: Array },
    gk: { type: String },
  },
  data() {
    return {
      GkUserList: [],
      dialogVisible: false,
      datas: {
        gk: '',
      },
    };
  },
  created() {
    this.$api.clienteleApi.getGkUserList().then(res => {
      this.GkUserList = res.data
    })
  },
  methods: {
    // 保存
    save() {
      console.log(this.ids);
      let datas = {
        user_id_set: this.ids,
        gk: this.datas.gk
      }
      this.$api.clienteleApi.setGkUser(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false
        this.$parent.clientList();
      });
    },
  },
  watch: {
    dialogVisible() {
      // if (this.dialogVisible) {
      //   this.datas.gk = this.gk
      // }
    },
  }
  ,
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 30px;
  display: flex;

  .el-select {
    width: 100%;
  }

  .label {
    flex: 1;
    line-height: 40px;
  }

  .val {
    flex: 3;
  }
}
</style>